import { newSocket } from "@monolith/helpers";
export default {
  data() {
    return {
      //channel: this.$.appContext.config.globalProperties.channel,
      // channel: newSocket.setUpChannel(this, this.$store),
      channel: null,
      channelListenersUp: this.$.appContext.config.globalProperties.channelListenersUp,
    };
  },

  async created() {
    if (!this.channel || this.channel.state != "joined") {
      this.channel = newSocket.setUpChannel(this, this.$store);
    }

    if (process.env.VUE_APP_FEATURE_FLAGS == "pos") {

      const cart = window.localStorage.getItem("cart");
      if (cart) {
        try{
          this.$store.dispatch("initialiseCartFromLocalStorage", JSON.parse(cart));
        } catch(error){
          console.log(error);
        }
      }

      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        window.localStorage.setItem(
          "cart",
          JSON.stringify({
            products: state.cart.added,
            payments: state.cart.payments,
          })
        );
      });
    }
  },
};
